import { isEmpty } from 'lodash';
import { ActionButton } from '../../components/vertical-dot/popper';
import { TableBodyCellColumn, TableBodyCellColumnCenter } from '../style/table.styled';
import moment from 'moment';
import { DATE_FORMAT } from '../common';

enum InitializationStatus {
  Initializing = 'Initializing',
  Initialized = 'Initialized',
  Failed = 'InitializationFailed ',
}

export const SwitchSandboxHeader = ({
  actions,
  tableActions,
}: {
  actions: any;
  tableActions: any;
}): any[] => {
  const newActions = [
    ...(actions || []),
    {
      accessor: 'actions',
      width: 20,
      sortable: false,
      isSubHeader: false,
      renderCell: true,
      Cell: ({ row }: any) => {
        let finalActions = [...tableActions];
        if (row.original.initializationStatus === InitializationStatus.Initializing) {
          finalActions = finalActions.filter((action: any) => action.as === 'Edit');
        }
        return (
          <td>
            {!row.original?.isDeleteProcessing && (
              <ActionButton
                actions={finalActions}
                id={row.original.tenantId}
                rowData={row.original}
                counter={parseInt(row?.tenantId)}
              />
            )}
          </td>
        );
      },
    },
  ];

  return newActions;
  return [
    {
      Header: 'Name',
      accessor: 'name',
      width: 150,
      sortable: true,
    },
    {
      Header: 'Description',
      accessor: 'description',
      width: 150,
      sortable: true,
      Cell: ({ row }: any) => {
        return (
          <TableBodyCellColumn className=''>
            <div className='cellTitle '>
              {!isEmpty(row.original.description) ? row.original.description : '-'}
            </div>
          </TableBodyCellColumn>
        );
      },
    },
    {
      Header: 'Created At',
      accessor: 'createdAt',
      width: 150,
      sortable: true,
      Cell: ({ row }: any) => {
        return (
          <TableBodyCellColumn>
            {!isEmpty(row.original.createdAt)
              ? moment(row.original.createdAt).format(DATE_FORMAT)
              : '-'}
          </TableBodyCellColumn>
        );
      },
    },
    {
      Header: 'Created by',
      accessor: 'createdBy',
      width: 150,
      sortable: true,
    },
    {
      Header: '',
      accessor: 'actions',
      width: 80,
      sortable: false,
      Cell: ({ row }: any) => {
        return (
          <div>
            {
              <ActionButton
                actions={tableActions}
                id={row.original.tenantId}
                rowData={row.original}
                counter={parseInt(row?.tenantId)}
              />
            }
          </div>
        );
      },
    },
  ];
};
